@if (redisForm) {
  <div class="form-container" [formGroup]="redisForm">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>Parameters</mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label">Name</label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="redisForm"></clickatell-form-validation>
          <input class="control-input" [activeForm]="redisForm" formControlName="name" placeholder="Enter a name" />
        </div>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label">Description</label>
          </div>
          <clickatell-form-validation [controlName]="'description'"
          [form]="redisForm"></clickatell-form-validation>
          <input class="control-input" [activeForm]="redisForm" formControlName="description"
            placeholder="Enter description" />
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Redis Action </label>
            </div>
            <clickatell-form-validation [controlName]="'redisAction'"
            [form]="redisForm"></clickatell-form-validation>
            <mat-select
              #redisAction
              class="control-dropdown"
              id="redisAction"
              [placeholder]="'Select an option'"
              [formControlName]="'redisAction'"
              (selectionChange)="actionChange(redisAction.value)">
              <mat-option value="decr">Decrement</mat-option>
              <mat-option value="decrBy">Decrement By</mat-option>
              <mat-option value="del">Delete</mat-option>
              <mat-option value="exist">Exist</mat-option>
              <mat-option value="get">Get</mat-option>
              <mat-option value="incr">Increment</mat-option>
              <mat-option value="incrBy">Increment By</mat-option>
              <mat-option value="set">Set</mat-option>
            </mat-select>
          </div>
          @if (redisAction.value) {
            <div>
              <ng-container
                *ngTemplateOutlet="redisActions; context: {redisAction: redisAction.value}">
              </ng-container>
            </div>
          }
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <div class="control-result">
            <div class="control-result-header">
              Yes
            </div>
            <div class="control-result-container">
              <div class="control-div">
                <label class="control-label">
                  <span class="pont-to">Point To</span>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                </label>
                @if (nodeFlowDetails) {
                  <next-selector [canEditFlows]="canEdit.canEditFlows"
                    [selectorType]="'both'"
                    [flowSteps]="nodeFlowDetails.currentFlowSteps"
                    [flows]="nodeFlowDetails.flows"
                    [name]="'yes'"
                    [form]="redisForm"
                    [stepId]="nodeFlowDetails.stepId">
                  </next-selector>
                }
              </div>
            </div>
          </div>
          <div class="control-result">
            <div class="control-result-header">
              No
            </div>
            <div class="control-result-container">
              <div class="control-div">
                <label class="control-label">
                  <span class="pont-to">Point To</span>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                </label>
                @if (nodeFlowDetails) {
                  <next-selector [canEditFlows]="canEdit.canEditFlows"
                    [selectorType]="'both'"
                    [flowSteps]="nodeFlowDetails.currentFlowSteps"
                    [flows]="nodeFlowDetails.flows"
                    [name]="'no'"
                    [form]="redisForm"
                    [stepId]="nodeFlowDetails.stepId">
                  </next-selector>
                }
              </div>
            </div>
          </div>
        </ng-container>
      </clickatell-expansion-panel>
    </div>
  }

  <ng-template #redisActions let-redisAction="redisAction">
    <div>
      @switch (redisAction) {
        @case ('decr') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis2">
            </ng-container>
          </div>
        }
        @case ('decrBy') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis3">
            </ng-container>
          </div>
        }
        @case ('del') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis1">
            </ng-container>
          </div>
        }
        @case ('exist') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis1">
            </ng-container>
          </div>
        }
        @case ('get') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis1">
            </ng-container>
          </div>
        }
        @case ('incr') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis2">
            </ng-container>
          </div>
        }
        @case ('incrBy') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis3">
            </ng-container>
          </div>
        }
        @case ('set') {
          <div>
            <ng-container
              *ngTemplateOutlet="redis3">
            </ng-container>
          </div>
        }
      }
    </div>
  </ng-template>


  <ng-template #redis1>
    <ng-container [formGroup]="logicForm">
      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label">Key</label>
        </div>
        <clickatell-form-validation [controlName]="'key'"
        [form]="logicForm"></clickatell-form-validation>
        <input class="control-input" [activeForm]="logicForm" formControlName="key" placeholder="Enter a key" />
      </div>
    </ng-container>
  </ng-template>

  <ng-template #redis2>
    <ng-container [formGroup]="logicForm">
      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label">Key</label>
        </div>
        <clickatell-form-validation [controlName]="'key'"
        [form]="logicForm"></clickatell-form-validation>
        <input class="control-input" [activeForm]="logicForm" formControlName="key" placeholder="Enter a key" />
      </div>

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label">Expire (days)</label>
        </div>
        <clickatell-form-validation [controlName]="'expire'"
        [form]="logicForm"></clickatell-form-validation>
        <input class="control-input" [activeForm]="logicForm" formControlName="expire" placeholder="1 – 30" type="number" />
      </div>
    </ng-container>
  </ng-template>

  <ng-template #redis3>
    <ng-container [formGroup]="logicForm">
      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label">Key</label>
        </div>
        <clickatell-form-validation [controlName]="'key'"
        [form]="logicForm"></clickatell-form-validation>
        <input class="control-input" [activeForm]="logicForm" formControlName="key" placeholder="Enter a key" />
      </div>

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label">Expire (days)</label>
        </div>
        <clickatell-form-validation [controlName]="'expire'"
        [form]="logicForm"></clickatell-form-validation>
        <input class="control-input" [activeForm]="logicForm" formControlName="expire" placeholder="1 – 30" type="number" />
      </div>

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label">Value</label>
        </div>
        <clickatell-form-validation [controlName]="'value'"
        [form]="logicForm"></clickatell-form-validation>
        <input class="control-input" [activeForm]="logicForm" formControlName="value" placeholder="Enter a value" />
      </div>
    </ng-container>
  </ng-template>